/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_DeletedInputs */

const zh_course_deleted = /** @type {(inputs: Course_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程已删除`)
};

const en_course_deleted = /** @type {(inputs: Course_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course deleted`)
};

const es_course_deleted = /** @type {(inputs: Course_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curso eliminado`)
};

/**
* | output |
* | --- |
* | "Course deleted" |
*
* @param {Course_DeletedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_deleted = /** @type {((inputs?: Course_DeletedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_DeletedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_deleted(inputs)
	if (locale === "en") return en_course_deleted(inputs)
	return es_course_deleted(inputs)
});